var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserDeactivProjectsOwned = function SvgUserDeactivProjectsOwned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "320px",
    height: "240px",
    viewBox: "0 0 320 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "illustrations / upgrade")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "admin_users_deactivate_user_GRID-L---1440_S9",
    transform: "translate(-544, -227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MODAL_SHARE-WITH-PROJECTS-Copy-4",
    transform: "translate(420, 119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustrations-/-upgrade",
    transform: "translate(124, 108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BOUNDS",
    x: 0,
    y: 0,
    width: 320,
    height: 240
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.484326,159.484262 L160.5,159.5 C161.175619,71.6576931 232.508793,0.508656018 320.5,0.5 L320.484326,159.484262 Z",
    id: "SHAPE",
    fill: "#F2F6F8",
    fillRule: "nonzero",
    transform: "translate(240.5, 80) rotate(90) translate(-240.5, -80)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "deactivate-icon",
    transform: "translate(88, 48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,0 C88.1631341,0 103.433193,5.22349192 116.152153,15.1037051 C117.646003,16.2639902 117.916312,18.4157611 116.755929,19.9093949 C115.595565,21.4030036 113.443811,21.673416 111.950308,20.5131348 C100.442171,11.5735879 86.6299967,6.84955752 72,6.84955752 C36.0764425,6.84955752 6.84955752,36.0764425 6.84955752,72 C6.84955752,90.0604607 14.1120962,106.921141 27.0760096,119.207666 L27.6516409,119.74674 L27.9869735,120.052673 L28.0271834,119.882801 C32.7878905,100.148705 50.2664619,85.8838537 70.7365133,85.3183228 L71.3577235,85.3053872 L72,85.300885 C92.8001407,85.300885 110.749925,99.4540669 115.825176,119.277721 L115.97502,119.880165 L116.014301,120.051398 L116.350732,119.744345 C129.292726,107.768093 136.718238,91.2988414 137.132155,73.5683187 L137.145997,72.7735825 L137.150442,72 C137.150442,60.0442571 133.892758,48.3598058 127.730002,38.209822 C126.748143,36.5930258 127.262854,34.4867358 128.879949,33.5046959 C130.49727,32.5236194 132.603119,33.0383543 133.584667,34.6548602 C140.398462,45.8770196 144,58.7907977 144,72 C144,111.757356 111.82959,144 72,144 C32.2027234,144 0,111.787541 0,72 C0,52.7554509 7.4857568,34.6690368 21.0761259,21.0781052 C34.6669115,7.48647597 52.7539455,0 72,0 Z M71.9974513,92.1498053 L71.4207654,92.1546659 C52.7182148,92.4275701 37.1346316,105.89735 34.1315445,124.20813 L34.0171327,124.951221 L34.3807208,125.21291 C45.1859703,132.875461 57.836961,136.980925 71.166059,137.145304 L72,137.150442 C85.637017,137.150442 98.5923706,133.035323 109.622378,125.213705 L109.984142,124.952496 L109.958653,124.765965 C107.210239,106.377321 91.8025925,92.7093695 73.1573348,92.1672219 L72.5855603,92.1547346 L71.9974513,92.1498053 Z M72,29.5486726 C86.1856947,29.5486726 97.7256637,41.0886416 97.7256637,55.2743363 C97.7256637,69.460031 86.1856947,81 72,81 C57.8143053,81 46.2743363,69.460031 46.2743363,55.2743363 C46.2743363,41.0886416 57.8143053,29.5486726 72,29.5486726 Z M72,36.3982301 C61.5922788,36.3982301 53.1238938,44.8666151 53.1238938,55.2743363 C53.1238938,65.6820575 61.5922788,74.1504425 72,74.1504425 C82.4077212,74.1504425 90.8761062,65.6820575 90.8761062,55.2743363 C90.8761062,44.8666151 82.4077212,36.3982301 72,36.3982301 Z M123.292035,22.8584071 C125.183488,22.8584071 126.716814,24.3917328 126.716814,26.2831858 C126.716814,28.1746389 125.183488,29.7079646 123.292035,29.7079646 C121.400582,29.7079646 119.867257,28.1746389 119.867257,26.2831858 C119.867257,24.3917328 121.400582,22.8584071 123.292035,22.8584071 Z",
    id: "icon",
    fill: "#B0BFC7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(90, 90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7142857,0 C11.5361965,0 0,11.5361965 0,25.7142857 C0,39.8923749 11.5361965,51.4285714 25.7142857,51.4285714 C39.8923749,51.4285714 51.4285714,39.8923749 51.4285714,25.7142857 C51.4285714,11.5361965 39.8923749,0 25.7142857,0 Z",
    id: "Path-Copy",
    stroke: "#B0BFC7",
    strokeWidth: 5,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B0BFC7",
    x: 10.2857143,
    y: 21.8571429,
    width: 30.8571429,
    height: 7.71428571,
    rx: 3.85714286
  })))))))));
};
export default SvgUserDeactivProjectsOwned;